import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
const INITIAL_STATE = {
  'url': '',
  'loading': false,
};
export const dowloadAuditFloatingReportWait = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_FLOAT_INVENTORY_AUDIT_EXCEL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_EXCEL]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.excel,
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_AUDIT_EXCEL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
    [ActionTypes.CLEAR_FLOAT_INVENTORY_AUDIT_EXCEL]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
export const dowloadAuditFloatingClientReportWait = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_FLOAT_CLIENT_INVENTORY_AUDIT_EXCEL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_CLIENT_AUDIT_EXCEL]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.excel,
    }),
    [ActionTypes.FETCHED_FLOAT_INVENTORY_CLIENT_AUDIT_EXCEL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
